import type { Locale, Translations } from "./types"

import a11yPt from "./translations/pt/a11y.json"
import navPt from "./translations/pt/nav.json"
import heroPt from "./translations/pt/hero.json"
import aboutUsPt from "./translations/pt/aboutUs.json"
import areasPt from "./translations/pt/areas.json"
import clientsPt from "./translations/pt/clients.json"
import servicesPt from "./translations/pt/services.json"
import projectsPt from "./translations/pt/projects.json"
import productsPt from "./translations/pt/products.json"
import contactPt from "./translations/pt/contact.json"
import footerPt from "./translations/pt/footer.json"
import notFoundPt from "./translations/pt/notFound.json"
import legalPt from "./translations/pt/legal.json"
import sectionCtasPt from "./translations/pt/sectionCtas.json"

import a11yEn from "./translations/en/a11y.json"
import navEn from "./translations/en/nav.json"
import heroEn from "./translations/en/hero.json"
import aboutUsEn from "./translations/en/aboutUs.json"
import areasEn from "./translations/en/areas.json"
import clientsEn from "./translations/en/clients.json"
import servicesEn from "./translations/en/services.json"
import projectsEn from "./translations/en/projects.json"
import productsEn from "./translations/en/products.json"
import contactEn from "./translations/en/contact.json"
import footerEn from "./translations/en/footer.json"
import notFoundEn from "./translations/en/notFound.json"
import legalEn from "./translations/en/legal.json"
import sectionCtasEn from "./translations/en/sectionCtas.json"

const pt: Translations = {
  a11y: a11yPt,
  nav: navPt,
  hero: heroPt,
  aboutUs: aboutUsPt,
  areas: areasPt,
  clients: clientsPt,
  services: servicesPt,
  projects: projectsPt,
  products: productsPt as Translations["products"],
  contact: contactPt,
  footer: footerPt,
  notFound: notFoundPt,
  legal: legalPt,
  sectionCtas: sectionCtasPt,
}

const en: Translations = {
  a11y: a11yEn,
  nav: navEn,
  hero: heroEn,
  aboutUs: aboutUsEn,
  areas: areasEn,
  clients: clientsEn,
  services: servicesEn,
  projects: projectsEn,
  products: productsEn as Translations["products"],
  contact: contactEn,
  footer: footerEn,
  notFound: notFoundEn,
  legal: legalEn,
  sectionCtas: sectionCtasEn,
}

export const translations: Record<Locale, Translations> = { pt, en }
